import { InstanceStatus } from "@/components/instance/InstanceStatus";
import { useFormatter } from "@/hooks/useFormatter";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { PoolsActions, PoolsDetailTabs } from "@/resources-def/pools-comp";
import { useTranslation } from "react-i18next";

const RESOURCE = 'subscriptions';

export const SubscriptionPage = () => {
  const { t } = useTranslation();
  const { formatDateTime } = useFormatter();

  const columns = [
    { title: t("subscription.fields.id", "Id"), dataIndex: "info.id", render: (text, record) => { return <div>{record.info.id}</div> } },
    { title: t("subscription.fields.product", "Product"), dataIndex: "info.name", render: (text, record) => { return <div>{record.info.name}</div> }},
    { title: t("subscription.fields.type", "Type"), dataIndex: "info.type", render: (text, record) => { return <div>{record.info.type}</div> } },
    { title: t("subscription.fields.code", "Code"), dataIndex: "info.code", render: (text, record) => { return <div>{record.info.code}</div> } },
    { title: t("subscription.fields.visibility", "Visibility"), dataIndex: "info.visibility", render: (text, record) => { return <div>{record.info.visibility}</div> } },
    // { title: t("subscription.fields.entitlement", "Entitlement"), dataIndex: "entitlement" },
    { title: t("subscription.fields.freeTrial", "Free Trial"), dataIndex: "free_trial" },
    { title: t("subscription.fields.freeTrialUpdatedTime", "Free Trial Updated Time"), dataIndex: "free_trial_updated_time" },
    { title: t("subscription.fields.offerIdentifier", "Offer Identifier"), dataIndex: "offer_identifier" },
    { title: t("subscription.fields.subscription", "Subscription"), dataIndex: "subscription" },
    { title: t("subscription.fields.subscriptionupdatedTime", "Subscription Updated Time"), dataIndex: "subscription_updated_time",  render: (value) => formatDateTime(value)},
  ];

  return (
    <ResourceListLayout
      resource={RESOURCE}
      columns={columns}
    >
    </ResourceListLayout>
  );
};